/*
 * SCRIPT FOR ENABLING AGE VERIFICATION ON CART PAGE
 * Developer - Alexey Osipov (aosipovdev@gmail.com)
 * cart_age_verification.js
 *
 */

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    console.log("The custom script for the cart page has been loaded");

    if (window.location.pathname === "/cart") {
      console.log("Cart page detected");

      const cartItemsContainer = document.querySelector(".cart__items");
      const checkoutButton = document.querySelector(
        "#cartForm > div > div.cart__aside > collapsible-elements > div > div > div > div > fieldset > button"
      );
      const ageErrorElement = document.querySelector(".age-error-message");
      const acceptanceCheckbox = document.getElementById("acceptance");
      const ageVerificationCheckbox = document.getElementById("confirmAge");
      const ageVerificationLabel = document.querySelector(
        "[data-cart-confirm-age-label]"
      );

      let ageVerifyProductInCart = false;

      if (!checkoutButton) {
        console.warn("Checkout button not found!");
        return;
      }

      // Ensure the checkout button is always enabled
      checkoutButton.removeAttribute("disabled");
      checkoutButton.classList.remove("cart__buttons--disabled");

      function showAgeErrorMessage() {
        if (ageErrorElement) {
          console.log("Showing age error message");
          ageErrorElement.classList.add("is-expanded");
        }
      }

      function hideAgeErrorMessage() {
        if (ageErrorElement) {
          console.log("Hiding age error message");
          ageErrorElement.classList.remove("is-expanded");
        }
      }

      function showAgeVerification() {
        if (ageVerificationCheckbox && ageVerificationLabel) {
          ageVerificationCheckbox.style.display = "block";
          ageVerificationLabel.style.display = "block";
        }
      }

      function hideAgeVerification() {
        if (ageVerificationCheckbox && ageVerificationLabel) {
          ageVerificationCheckbox.style.display = "none";
          ageVerificationLabel.style.display = "none";
        }
      }

      function checkProductsInCart() {
        ageVerifyProductInCart = false;
        if (cartItemsContainer) {
          const cartItems = cartItemsContainer.querySelectorAll(".cart__item");

          cartItems.forEach((item) => {
            const productTitle = item.querySelector(
              ".cart__item__title a"
            ).textContent;

            if (desiredProducts.includes(productTitle)) {
              console.log("Desired product found in cart: " + productTitle);
              ageVerifyProductInCart = true;
              showAgeVerification();
            } else {
              console.log("Product in cart: " + productTitle);
            }
          });

          if (!ageVerifyProductInCart) {
            console.log("No products for age verification on cart page");
            hideAgeErrorMessage();
            hideAgeVerification();
          }
        } else {
          console.log("Cart items container not found on cart page");
        }
      }

      checkoutButton.addEventListener("click", function (event) {
        console.log("Checkout button clicked on cart page");
        let canProceed = true;

        if (!acceptanceCheckbox.checked) {
          console.log("Acceptance checkbox is not checked");
          canProceed = false;
        }

        if (ageVerifyProductInCart && !ageVerificationCheckbox.checked) {
          console.log("Age verification required but checkbox is not checked");
          showAgeErrorMessage();
          canProceed = false;
        } else {
          hideAgeErrorMessage();
        }

        if (!canProceed) {
          event.preventDefault(); // Prevent checkout if conditions aren't met
        }
      });

      if (ageVerificationCheckbox) {
        ageVerificationCheckbox.addEventListener("change", function () {
          if (!ageVerificationCheckbox.checked && ageVerifyProductInCart) {
            showAgeErrorMessage();
          } else {
            hideAgeErrorMessage();
          }
        });
      }

      if (acceptanceCheckbox) {
        acceptanceCheckbox.addEventListener("change", function () {
          // No action needed here for button state since it's always enabled
        });
      }

      // Monitor changes in the cart items, e.g., product removal
      const observerConfig = { childList: true, subtree: true };
      const cartObserver = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
            console.log(
              "Cart items changed, re-checking age verification requirements"
            );
            checkProductsInCart();
          }
        }
      });

      if (cartItemsContainer) {
        cartObserver.observe(cartItemsContainer, observerConfig);
      }

      const desiredProducts = [
        "Mindful Microdosing",
        "Mindful Microdosing Program",
        "Radical Wellbeing Set",
      ];

      // Initial check
      checkProductsInCart();
    }
  });
})();